import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicEvent } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const getMyEvents = async (orgId: string): Promise<PublicEvent[]> => {
  const response = await axiosClient.get(`/${orgId}/my-events`);
  return response.data;
};

export const getMyEventsQueryKey = (orgId?: string) => [
  "my-events",
  orgId ? `org-${orgId}` : "no-org",
];

export function useGetMyEvents(
  orgId: string,
  queryOptions?: UseQueryOptions<PublicEvent[], HttpError>,
) {
  return useQuery({
    queryKey: getMyEventsQueryKey(orgId),
    queryFn: () => getMyEvents(orgId),
    ...queryOptions,
  });
}
